import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

export class ReportSlider {
  constructor() {
    const elm = document.getElementById('js-report_slider')
    if (!elm) return
    function navigation(slider) {
      let wrapper, dots, arrowLeft, arrowRight

      function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment)
      }
      function createDiv(className) {
        var div = document.createElement('div')
        var classNames = className.split(' ')
        classNames.forEach((name) => div.classList.add(name))
        return div
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft)
          removeElement(arrowRight)
          return
        }
        arrowLeft = createDiv('c-slider_arrow -left')
        arrowLeft.addEventListener('click', () => slider.prev())
        arrowRight = createDiv('c-slider_arrow -right')
        arrowRight.addEventListener('click', () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
      }

      function wrapperMarkup(remove) {
        if (remove) {
          var parent = wrapper.parentNode
          while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper)
          removeElement(wrapper)
          return
        }
        wrapper = createDiv('c-slider_navigation')
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
      }

      function dotMarkup(remove) {
        if (remove) {
          removeElement(dots)
          return
        }
        dots = createDiv('c-slider_dots')
        slider.track.details.slides.forEach((_e, idx) => {
          var dot = createDiv('dot')
          dot.addEventListener('click', () => slider.moveToIdx(idx))
          dots.appendChild(dot)
        })
        wrapper.appendChild(dots)
      }

      function updateClasses() {
        var slide = slider.track.details.rel
        slide === 0 ? arrowLeft.classList.add('is-disabled') : arrowLeft.classList.remove('is-disabled')
        slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add('is-disabled') : arrowRight.classList.remove('is-disabled')
        Array.from(dots.children).forEach(function (dot, idx) {
          idx === slide ? dot.classList.add('is-act') : dot.classList.remove('is-act')
        })
      }

      slider.on('created', () => {
        markup()
        updateClasses()
      })
      slider.on('optionsChanged', () => {
        console.log(2)
        markup(true)
        markup()
        updateClasses()
      })
      slider.on('slideChanged', () => {
        updateClasses()
      })
      slider.on('destroyed', () => {
        markup(true)
      })
    }

    const slider = new KeenSlider(
      elm,
      {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
        },
      },
      [navigation],
    )
  }
}
